<template>
  <v-card flat class="product-view">
    <v-card-title class="pa-1 pt-0">
      <v-text-field solo dense hide-details ref="scanFocus" v-model="scanCode" id="scanCode"
      @click="selectContent" autocomplete="off"
      @change="getRespectiveProductOrder"
      :placeholder="$t('message.dashboard.scanText')"></v-text-field>
    </v-card-title>
    <v-card-text>
      <div class="text-center" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <template v-if="productMeta">
        <v-row>
          <v-col cols="12" class="pa-1 pt-0 pb-0">{{ productMeta.productname }}</v-col>
          <v-col cols="12" class="pa-1 pt-0 pb-0">{{ productMeta.suppliername }}</v-col>
        </v-row>
        <v-row class="mb-1">
          <v-col cols="6" class="pa-1 highlight font-weight-bold">{{ $t('message.product.minQty') }}: {{ productMeta.productminqty | replaceDotWithComma }}</v-col>
          <v-col cols="6" class="pa-1 highlight font-weight-bold">{{ $t('message.product.orderQty') }}: 0</v-col>
        </v-row>
        <v-row class="highlight" v-for="location in listOfLocations" :key="location.locationid">
          <v-col cols="6" class="pa-1">
            {{ $t('message.order.location') }}:{{ location.locationname }}
          </v-col>
          <v-col cols="6" class="pa-1">
            {{ $t('message.product.qty') }}: {{ location.onstock | replaceDotWithComma }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0" v-for="(order, index) in listOfCustomerOrders" :key="`${index}_customer`">
            <customer-item :isList="false" :model="order"></customer-item>
          </v-col>
          <v-col cols="12" class="pa-0 pt-0" v-for="(order, index) in listOfSupplierOrders" :key="`${index}_supplier`">
            <supplier-item type="supplier" :isList="false" :model="order"></supplier-item>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <h3>{{ $t('message.product.noProductFound') }}</h3>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      scanCode: '',
      productMeta: null,
      listOfLocations: [],
      listOfCustomerOrders: [],
      listOfSupplierOrders: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getScannedCode'])
  },
  components: {
    'customer-item': () => import('@/components/Order/CustomerItem'),
    'supplier-item': () => import('@/components/Order/OrderItem')
  },
  mounted () {
    requestAnimationFrame(() => {
      if (this.$refs.scanFocus) {
        this.$refs.scanFocus.focus()
      }
    })
    this.scanCode = this.getScannedCode || ''
    this.getRespectiveProductOrder()
  },
  methods: {
    getRespectiveProductOrder () {
      if (this.scanCode) {
        this.loading = true
        this.$api.execute('post', `products/get_product_info/${this.scanCode}`, {})
          .then((response) => {
            if (response.data) {
              let { prouductinfo, customerorders, supplierorders } = response.data
              this.productMeta = prouductinfo ? prouductinfo[0] : null
              this.listOfLocations = prouductinfo ? prouductinfo.filter(x => x.onstock > 0) : []
              this.listOfCustomerOrders = customerorders
              this.listOfSupplierOrders = supplierorders
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    selectContent () {
      if (this.$refs.scanFocus) {
        setTimeout(() => {
          document.getElementById('scanCode').select()
        }, 50)
      }
    }
  }
}
</script>
